<template>
  <v-card flat v-if="product" class="product-list-item pointer" @click="jump">
    <v-layout wrap>
      <v-flex class="item-img-wrap mr-4" shrink>
        <img :src="product.img">
        <div class="category-tag">{{tag}}</div>
      </v-flex>
      <v-flex class="item-content">
        <v-layout column justify-space-between fill-height>
          <v-layout justify-space-between shrink wrap>
            <v-flex xs12 md8>
              <h2>{{product.title}}</h2>
            </v-flex>
            <v-flex xs12 md4 class="text-md-right text-xs-left text2">{{product.company.name}}</v-flex>
          </v-layout>
          <v-layout class="features" wrap>
            <!-- 移动端显示 -->
            <table v-if="breakpoint.xs">
              <tr v-for="item in product.features" :key="item">
                <td class="features-item text2">
                  <span>{{item}}</span>
                </td>
              </tr>
            </table>
            <!-- PC显示 -->
            <table v-else>
              <template v-for="n in product.features.length">
                <tr v-if="n % 2 === 1" :key="n">
                  <td class="features-item text2">
                    <span>{{product.features[n-1]}}</span>
                  </td>
                  <td class="features-item text2">
                    <span v-if="n < product.features.length">{{product.features[n]}}</span>
                  </td>
                </tr>
              </template>
            </table>
          </v-layout>

          <v-layout class="conditions-wrap" :class="{'mt-3':breakpoint.xs}" align-end wrap>
            <v-flex xs12 md9 class="conditions">
              <v-layout column justify-end>
                <v-flex v-for="item in product.conditions" :key="item.title">
                  <c-icon :name="item.icon"></c-icon>
                  <span>{{ item.title }}： {{item.content}}</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md3 :class="{'mt-3':breakpoint.xs}">
              <div class="primary-text text-xs-right" v-html="product.price"></div>
            </v-flex>
          </v-layout>
          <v-layout v-if="product.hasOwnProperty('button') && product.button === true">
            <v-flex style="position: relative;text-align: right;">
              <v-btn color="primary" style="position: absolute; right: 0; width: 180px;height: 40px;bottom: 0">立即投保
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    code: String
  },
  data() {
    return {
    };
  },
  computed: {
    product() {
      return this.$store.getters.getProduct(this.code);
    },
    tag() {
      return this.product && this.product.isGroup ? "团体保障" : "个人保障";
    }
  },
  mounted(){
  },
  methods: {
    jump() {
      if (this.product.hasOwnProperty("toUrl")){
        return location.href = this.product.toUrl;
      }
      this.$router.push(`/product/detail/${this.code}`);
    },
    jumpOutUrl(){

    }
  }
};
</script>

<style lang="scss" scoped>
@mixin sm-media {
  @media only screen and (max-width: map-get($breakpoints, sm)) {
    @content;
  }
}
.product-list-item {
  h2 {
    font-weight: 400;
  }
  padding: 30px;
  margin-bottom: 20px;
  .item-img-wrap {
    width:300px;
    overflow: hidden;
    text-align: center;
    position: relative;
    height: 220px;
    img{
      width: 100%;
      height: 100%;
    }
    .category-tag {
      position: absolute;
      top: 0;
      left: 0;
      padding: 7px 13px;
      border-bottom-right-radius: 19px;
      background-color: #292c31;
      opacity: 0.7;
      color: rgba(255, 255, 255, 0.7);
    }
  }
  .item-content {
    @include sm-media {
      margin-top: 1em;
    }
  }

  .features {
    margin-top: 20px;
    font-size: 15px;
    &-item {
      padding-right: 25px;
      span:before {
        content: "•";
        color: $primary-color;
        width: 5px;
        height: 5px;
        margin-right: 5px;
      }
    }
  }
}
</style>

<style lang="scss">
.product-list-item {
  .conditions-wrap {
    .primary-text {
      strong {
        font-size: 28px;
        font-weight: 400;
      }
    }
  }
}
</style>


